import React from 'react';

import { useEmptyChatLaunchSelector } from '@atlassian/conversation-assistant-store/controllers/ui-store';
import { useForYouNavigationState } from '@atlassian/rovo-for-you/navigation-store';

import { useActiveTabContext } from '../active-tab-provider/useActiveTabContext';
import { FOR_YOU_TAB_ID } from '../chat-history/rovo-tabs/constants';

/** Subscribes to tab + For You navigation only when Rovo tabs are enabled. */
export const MiniModalForYouThreadsListHidesInput = ({
	children,
}: {
	children: React.ReactNode;
}): React.JSX.Element | null => {
	const { activeTabId } = useActiveTabContext();
	const { currentView } = useForYouNavigationState();
	const [{ customGreeting: runtimeCustomGreeting }] = useEmptyChatLaunchSelector();
	const isEmptyChatLaunchActive = Boolean(runtimeCustomGreeting);
	const shouldHide =
		!isEmptyChatLaunchActive &&
		activeTabId === FOR_YOU_TAB_ID &&
		currentView.type === 'threads-list';

	if (shouldHide) {
		return null;
	}
	return <>{children}</>;
};
